import { Suspense } from 'react';
import { ArtistContacts, ArtistGeneralInformation } from '@features';
import { Grid, Skeleton, Stack } from '@mantine/core';

const COL_SPAN = { base: 12, md: 6 };
const SKELETON_MIN_HEIGHT = 100;

export const ArtistDetailsGeneralPage: React.FC = () => {
  return (
    <Stack py="md">
      <Grid>
        <Grid.Col span={COL_SPAN}>
          <Suspense fallback={<Skeleton mih={SKELETON_MIN_HEIGHT} />}>
            <ArtistGeneralInformation />
          </Suspense>
        </Grid.Col>
        <Grid.Col span={COL_SPAN}>
          <Suspense fallback={<Skeleton mih={SKELETON_MIN_HEIGHT} />}>
            <ArtistContacts />
          </Suspense>
        </Grid.Col>
      </Grid>
    </Stack>
  );
};
